import { useEffect, useCallback, useState } from "react";
import api from "api";
import { checkContinuePeriod } from "date";
import logo from "assets/logo.jpg";
import 'styles/quotedeliverybill.css';
import QuoteSearchBar from "components/quoteComponents/QuoteSearchBar";

const QuoteDeliveryBill = (
    {
        setDeliveryBill,
        selectedQuote,
    }
) => {
    
    const [ quote, setQuote ] = useState(null);
    const [ dates, setDates ] = useState(null);
    const [ tree, setTree ] = useState(null);
    const [ items, setItems ] = useState([]);
    const [ colors, setColors ] = useState(null); //

    const addItem = (item, quantity) => {
        setItems(prevItems => {
            const exists = prevItems.some(i => i.item.id === item.id);
            return exists ? prevItems : [...prevItems, { item, quantity }];
        });
    };    

    const removeAll = (i) => {
        setItems(prevItems => prevItems.filter((_, index) => index !== i));
    };
    
    const removeOne = (i) => {
        setItems(prevItems =>
            prevItems.map((obj, index) => 
                index === i && obj.quantity > 1 ? { ...obj, quantity: obj.quantity - 1 } : obj
            )
        );
    };
    
    const addOne = (i) => {
        setItems(prevItems =>
            prevItems.map((obj, index) => 
                index === i ? { ...obj, quantity: obj.quantity + 1 } : obj
            )
        );
    };

    // fonction pour traiter la touche ECHAP
    const handleKey = useCallback((e) => {
        if (e.key === 'Escape') {
            setDeliveryBill(false);
        }
    }, [setDeliveryBill]);

    // fonction pour intercepter le clavier
    useEffect(() => {
        document.addEventListener('keydown',handleKey);
        return () => { 
            document.removeEventListener('keydown',handleKey);
        }
    },[handleKey]);

    useEffect(()=>{
        api.get(`quote/${selectedQuote.id}`)
        .then((response)=>{
            setQuote(response.data);
        });
        api.get(`quote/${selectedQuote.id}/getdates`)
        .then((response)=>{
            const options = { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric'};
            const dates = response.data.map((date) => ({...date, formatted : new Date(date.timestamp).toLocaleDateString('fr-FR', options)}));
            setDates(dates);
        });
        api.get(`quote/${selectedQuote.id}/items`)
        .then((response)=>{
            setTree(response.data);
        });
         api.get(`quote/${selectedQuote.id}/getinfos`)
        .then((response)=>{
            setColors(response.data);
        });
    },[selectedQuote]);
    
    return (
        <>
            {
                quote
                &&
                <div id="QDB">
                    <div id="QDB-header">
                        <div id="QDB-provider">
                            <img src={logo} alt=""/>
                            <div id = "QDB-adress">
                                <div>MEB SON LUMIÈRE</div>
                                <div>1 rue Louis Lépine</div>
                                <div>19100 BRIVE LA GAILLARDE</div>
                                <div>Site web : <a href="https//meb19.fr">meb19.fr</a></div>
                            </div>
                        </div>
                        <div id="QDB-titlebox">
                            <div id='QDB-title'>
                                BON DE LIVRAISON
                            </div>
                            <div id='QDB-subtitle'>
                                Affaire suivie par : Damien Morisot - 06 86 99 19 61 - damien@meb19.fr
                            </div>
                        </div>
                    </div>
                    <div id='QDB-infos'>
                        <div id='QDB-general-infos'>
                            <div>
                                <span className="QDB-infos-label">Client :</span>
                                <span className="QDB-infos-value"> { quote.name }</span>
                            </div>
                            <div>
                                <span className="QDB-infos-label">Téléphone :</span>
                                <span className="QDB-infos-value"> { quote.phone }</span>
                            </div>
                            <div>
                                <span className="QDB-infos-label">Évènement :</span>
                                <span className="QDB-infos-value"> { quote.event }</span>
                            </div>
                        </div>
                        {
                            dates
                            &&
                            <div id='QDB-dates'>
                                <div id="QDB-dates-title">
                                    Date{ dates.length>1 ? 's' : ""} d'utilisation :
                                </div>
                                {
                                    dates.map((date)=>
                                        <div className="QDB-date" key={date.id}>
                                            {date.formatted}
                                        </div>
                                    )
                                }
                            </div>
                        }
                        {
                            dates
                            &&
                            checkContinuePeriod(dates)
                            &&
                            <div id='QDB-dates-infos'>
                                Le matériel peut être conservé sans surcoût entre les différents jours d'utilisation. Néanmoins il peut être rappelé à vos frais pour servir d'autres clients entre les dates d'utilisation.
                            </div>
                        }
                    </div>
                    <div id='QDB-list-title'>
                        MATÉRIEL LOUÉ
                    </div>
                    <QuoteSearchBar
                        quoteid={selectedQuote.id} // numéro du devis
                        setObjectToReload={addItem} // initialise un équipement à recharger
                        group={null} // groupe sélectionné
                        deliveryAdd={true}
                    />
                    <div id="QDB-list">
                        {tree &&
                            tree.map((group) => (
                                <div key={group.id} className="QDB-group">
                                    {group.id ? group.name : ""}
                                    {group.categories.map((category) => (
                                        <div key={category.id} className="QDB-category">
                                            {category.name}
                                            {category.subCategories.map((subCategory) => (
                                                <div key={subCategory.id} className="QDB-subCategory">
                                                    {subCategory.name}
                                                    {subCategory.items.map((item) => (
                                                        <div key={`quote${item.id}`} className="QDB-item">
                                                            <div className="QDB-item-name">{item.desc}</div>
                                                            <div className="QDB-item-quantity">{item.quantity}</div>
                                                        </div>
                                                    ))}
                                                </div>
                                            ))}
                                        </div>
                                    ))}
                                </div>
                            ))
                        }

                        {items.length > 0 && (
                            <div className="QDB-group">
                                <div className="QDB-category">
                                    Rajouté{items.length > 1 ? "s" : ""} à l'enlèvement :
                                    <div className="QDB-subCategory">
                                        {items.map((obj, index) => (
                                            <div key={`delivery${obj.item.id}`} className="QDB-item">
                                                <div className="QDB-item-name">{obj.item.desc}</div>
                                                <div className="QDB-item-quantity">
                                                    <span className="QDB-item-quantity-minor" onClick={() => removeOne(index)}>▼</span>
                                                    <span>{obj.quantity}</span>
                                                    <span className="QDB-item-quantity-major" onClick={() => addOne(index)}>▲</span>
                                                    <span className="QDB-item-delete" onClick={() => removeAll(index)}>🗑️</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="QDB-group QDB-category" id="QDB-flight-cases">Flight-cases :</div>
                    </div>

                    <div id="QDB-footer">
                        {
                            colors
                            &&
                            colors.isCable
                            &&
                            <>
                                <div id="QDB-color-codes">
                                    <div className="QDB-color-title">
                                        Code couleur câbles
                                    </div>
                                    <div className="QDB-color-line">
                                        <svg className="QDB-color-box-container">
                                            <rect className="QDB-color-box" style={{fill:"red"}}>
                                            </rect>
                                        </svg>
                                        <div className="QDB-color-string">3 mètres</div>
                                    </div>
                                    <div className="QDB-color-line">
                                        <svg className="QDB-color-box-container">
                                            <rect className="QDB-color-box" style={{fill:"yellow"}}>
                                            </rect>
                                        </svg>
                                        <div className="QDB-color-string">5 mètres</div>
                                    </div>
                                    <div className="QDB-color-line">
                                        <svg className="QDB-color-box-container">
                                            <rect className="QDB-color-box" style={{fill:"lightgreen"}}>
                                            </rect>
                                        </svg>
                                        <div className="QDB-color-string">10 mètres</div>
                                    </div>
                                    <div className="QDB-color-line">
                                        <svg className="QDB-color-box-container">
                                            <rect className="QDB-color-box" style={{fill:"orange"}}>
                                            </rect>
                                        </svg>
                                        <div className="QDB-color-string">15 mètres</div>
                                    </div>
                                    <div className="QDB-color-line">
                                        <svg className="QDB-color-box-container">
                                            <rect className="QDB-color-box" style={{fill:"blue"}}>
                                            </rect>
                                        </svg>
                                        <div className="QDB-color-string">20 mètres</div>
                                    </div>
                                </div>
                                {
                                    colors.isDMX
                                    &&
                                    <>
                                        <div id="QDB-color-codes">
                                            <div className="QDB-color-title">
                                                Code couleur DMX
                                            </div>
                                            <div className="QDB-color-line">
                                                <svg className="QDB-color-box-container">
                                                    <rect className="QDB-color-box" style={{fill:"darkviolet"}}>
                                                    </rect>
                                                </svg>
                                                <div className="QDB-color-string">3 points</div>
                                            </div>
                                            <div className="QDB-color-line">
                                                <svg className="QDB-color-box-container">
                                                    <rect className="QDB-color-box" style={{fill:"gray"}}>
                                                    </rect>
                                                </svg>
                                                <div className="QDB-color-string">5 points</div>
                                            </div>
                                        </div>
                                    </>
                                }
                            </>
                        }
                        <div id="QDB-return-date">Retour prévu le</div>
                    </div>
                </div>
            }
        </>
    );
};

export default QuoteDeliveryBill;